module.exports = __webpack_public_path__ + "static/media/preview.657b740e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/MemberProfile/preview.svg
// module id = 366
// module chunks = 0